export default `
var response = {
    messages: [
        "Mensagem do balão 1",
        "Mensagem do balão 2"
    ],
    updateVariables: [{
            "variavelName1": "valor da variável 1"
        },
        {
            "variavelName2": "valor da variável 2"
        }
    ]
};

done(response); // This is required.`;
